/**
 * BnthCountrySelector
 *
 * Extends the generic BnthSlidePanel (assets/bn3th-slide-panel.js) with
 * radio/apply handling shared by both instances of <bn3th-country-selector>:
 *   - Desktop dropdown (bn3th-country-selector-dropdown.liquid): trigger
 *     and list both live inside the element, found via [data-trigger].
 *   - Mobile panel (bn3th-country-selector-panel.liquid): the trigger
 *     button lives outside the element (it can't be nested inside
 *     .bn3th-mobile-menu__main, see that panel's docblock), so it's
 *     resolved externally via the data-trigger-selector attribute (handled
 *     by the base class).
 *
 * Radio handling ([data-radio]) is shared by both instances, but the two
 * differ once a selection changes: the mobile panel has an Apply button
 * ([data-apply]) that gates navigation, while the desktop dropdown has
 * none, so selecting a radio there navigates immediately.
 */
class BnthCountrySelector extends BnthSlidePanel {
  connectedCallback() {
    super.connectedCallback();

    this._apply = this.querySelector("[data-apply]");
    this._initialValue = this._checkedRadio()?.value ?? null;

    this._apply?.addEventListener("click", () => this._onApply());
    this.addEventListener("change", (event) => this._onRadioChange(event));
  }

  _checkedRadio() {
    return this.querySelector("[data-radio]:checked");
  }

  _onRadioChange(event) {
    if (!event.target.matches("[data-radio]")) return;

    if (this._apply) {
      this._apply.disabled = event.target.value === this._initialValue;
      return;
    }

    if (event.target.value && event.target.value !== this._initialValue) {
      window.location.href = event.target.value;
    }
  }

  _onApply() {
    const checked = this._checkedRadio();
    if (checked?.value) window.location.href = checked.value;
  }
}

customElements.define("bn3th-country-selector", BnthCountrySelector);
